import React from "react";
import NotFound from "../components/404/not-found";

export default function NotFoundPage() {
  return (
    <>
      <NotFound />
    </>
  );
}
